import { render, staticRenderFns } from "./EmailCommunication.vue?vue&type=template&id=1a9c9f1e&"
import script from "./EmailCommunication.vue?vue&type=script&lang=js&"
export * from "./EmailCommunication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports